import { useEffect } from 'react';

const upsertMeta = (attribute, key, content) => {
  if (content === undefined || content === null) {
    return;
  }
  const selector = `meta[${attribute}="${key}"]`;
  let meta = document.head.querySelector(selector);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  if (!href) {
    return;
  }
  let link = document.head.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

const upsertJsonLd = (id, data) => {
  const selector = `script[data-seo="${id}"]`;
  const existing = document.head.querySelector(selector);
  if (!data) {
    if (existing) {
      existing.remove();
    }
    return;
  }
  const script = existing || document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.setAttribute('data-seo', id);
  script.textContent = JSON.stringify(data);
  if (!existing) {
    document.head.appendChild(script);
  }
};

export const useSeo = ({
  title,
  description,
  canonical,
  robots,
  keywords,
  og,
  twitter,
  structuredData,
}) => {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta('name', 'title', title);
    }
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', robots);
    upsertMeta('name', 'keywords', keywords);
    upsertLink('canonical', canonical);

    if (og) {
      upsertMeta('property', 'og:title', og.title);
      upsertMeta('property', 'og:description', og.description);
      upsertMeta('property', 'og:url', og.url);
      upsertMeta('property', 'og:image', og.image);
      upsertMeta('property', 'og:image:alt', og.imageAlt);
      upsertMeta('property', 'og:type', og.type);
      upsertMeta('property', 'og:site_name', og.siteName);
      upsertMeta('property', 'og:locale', og.locale);
    }

    if (twitter) {
      upsertMeta('name', 'twitter:card', twitter.card);
      upsertMeta('name', 'twitter:title', twitter.title);
      upsertMeta('name', 'twitter:description', twitter.description);
      upsertMeta('name', 'twitter:url', twitter.url);
      upsertMeta('name', 'twitter:image', twitter.image);
      upsertMeta('name', 'twitter:image:alt', twitter.imageAlt);
      upsertMeta('name', 'twitter:site', twitter.site);
      upsertMeta('name', 'twitter:creator', twitter.creator);
      upsertMeta('name', 'twitter:domain', twitter.domain);
    }

    upsertJsonLd('structured-data', structuredData);
  }, [title, description, canonical, robots, keywords, og, twitter, structuredData]);
};
